export default "__VITE_ASSET__DYbHruz8__"